import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import ToggleOpenClose from '../ToggleOpenClose';
import FacetsContent from '../SiteSeeker/components/ColumnNavigation/FacetsContent';
import Accordion from '../Accordion';
import { GlobalsContext } from './context/globals';

const AdvancedFilters = ({ onChange, tags }) => {
  const {
    globals: { categories, isExperienceEditor, labels, types },
  } = useContext(GlobalsContext);
  const [isOpen, setIsOpen] = useState(isExperienceEditor);

  function onChangeFacet(event) {
    const checkBox = event.currentTarget;
    let updatedTags;
    const valueIndex = tags.indexOf(checkBox.value);
    if (valueIndex > -1) {
      updatedTags = [...tags];
      updatedTags.splice(valueIndex, 1);
    } else {
      updatedTags = [...tags, checkBox.value];
    }

    onChange(updatedTags);
  }

  const categoryFacets = categories.map((category) => ({
    ...category,
    checked: tags.indexOf(category.id) > -1,
  }));

  const typesFacets = types.map((type) => ({
    ...type,
    checked: tags.indexOf(type.id) > -1,
  }));

  const classNames = ClassNames({
    WhatsOnFilters_advancedFilters: true,
    WhatsOnAdvancedFilters: true,
    'WhatsOnAdvancedFilters-isOpen': isOpen,
    'WhatsOnAdvancedFilters-noTags': categories.length === 0 && types.length === 0,
  });

  return (
    <div className={classNames}>
      <Accordion
        isOpen={isOpen}
        onChange={(isDrawerOpen) => setIsOpen(isDrawerOpen)}
        toggleElement={({ onClose, onOpen }) => (
          <header className="WhatsOnAdvancedFilters_header">
            <ToggleOpenClose
              className="WhatsOnAdvancedFilters_toggleOpenClose"
              closeLabel={labels.advancedLabel}
              isOpen={isOpen}
              onClose={onClose}
              onOpen={onOpen}
              openLabel={labels.advancedLabel}
            />
          </header>
        )}
        drawerElement={({ drawerRef }) => (
          <div className="WhatsOnAdvancedFilters_drawer" ref={drawerRef}>
            <div className="WhatsOnAdvancedFilters_facets Facets Facets-whatsOn">
              <div className="Facets_whatsOnAdvancedWrapper">
                {categories && categories.length > 0 && (
                  <div className="WhatsOnAdvancedFilters_facetsContent">
                    <FacetsContent
                      disabled={!isOpen}
                      facets={categoryFacets}
                      facetTypeKey={'categories'}
                      onChange={onChangeFacet}
                      title={labels.categoriesLabel}
                    />
                  </div>
                )}

                {types && types.length > 0 && (
                  <div className="WhatsOnAdvancedFilters_facetsContent">
                    <FacetsContent
                      disabled={!isOpen}
                      facets={typesFacets}
                      facetTypeKey={'types'}
                      onChange={onChangeFacet}
                      title={labels.typesLabel}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
};

AdvancedFilters.propTypes = {
  onChange: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.string),
};

export default AdvancedFilters;
